/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import HeaderPage from './HeaderPage'
import useRecorder from './utils/useRecorder'
import { CirclesWithBar } from 'react-loader-spinner'
import { ArrowClockwise, Microphone, Pause, Record, Stop } from 'phosphor-react'
import axios from 'axios'
import CanvasComponent from './CanvasComponent'
import TranslatorInput from './transliteration/trans'
import ImageContainer from './ImageContainer'
import CaptchaTest from './CaptchaCode'
import { Link } from 'react-router-dom'

const LanguageList = {
    'en-IN': 'English',
    'hi-IN': 'हिंदी [Hindi]',
    'te-IN': 'తెలుగు [Telugu]',
    'ta-IN': 'தமிழ் [Tamil]',
    'kn-IN': 'ಕನ್ನಡ [Kannada]',
    'ml-IN': 'മലയാളം [Malayalam]',
    'mr-IN': 'मराठी [Marathi]',
    'gu-IN': 'ગુજરાતી [Gujarati]',
    'bn-IN': 'বাঙ্গালি [Bengali]',
    'ur-IN': 'اردو [Urdu]',
    'ru-RU': 'Русский [Russian]',
    'es-ES': 'Español [Spanish]',
    'fr-BE': 'Français [French]',
    'zh-TW': '中国人 [Chinese]',
    'ar-AE': 'عربي [Arabic]',
    'pt-PT': 'Português [Portuguese]',
    'su-ID': 'basa Sunda [Sundanese]',
    'de-AT': 'Deutsch [German]',
    'ja-JP': '日本 [Japanese]',
    'ko-KR': '한국인 [Korean]',
    'it-IT': 'Italiano [Italian]',
    'tr-TR': 'Türkçe [Turkish]',
    'ms-MY': 'Melayu [Malay]',
    'ps-AF': 'Pashto [Pashto]',
}
function TextToImage() {
    let [
        audioURL,
        isRecording,
        startRecording,
        stopRecording,
        pause,
        setPause,
        setResume,
    ] = useRecorder()
    const [loading, setLoading] = useState(false)
    const [vkeyboard, setvkeyboard] = useState(false)
    const [sourceLanguage, setSourceLanguage] = useState('')
    const [isVerified, setisVerified] = useState(false)
    const [Text, setText] = useState('')
    const [TransText, setTransText] = useState('')
    const [imageSrc, setImageSrc] = useState('')
    function trimSpecialCharacters(inputString) {
        // Use regular expression to remove all non-alphanumeric characters
        return inputString.replace(/[^a-zA-Z0-9 ]/g, '')
    }
    let unwantedWords = [
        'bad',
        'sample',
        'narendra',
        'naked',
        'modi',
        'prime',
        'minister',
        'inappropriate',
        'offensive',
        'vulgar',
        'obscene',
        'profanity',
        'hate',
        'sexy',
        'racist',
        'sexist',
        'discriminatory',
        'abusive',
        'insulting',
        'disrespectful',
        'disparaging',
        'derogatory',
        'indecent',
        'lewd',
        'nude',
        'sex',
        'crude',
        'disgusting',
        'repulsive',
        'revolting',
        'repugnant',
        'objectionable',
        'unpleasant',
        'disgraceful',
        'shameful',
        'scandalous',
        'unethical',
        'immoral',
        'sinful',
        'wicked',
        'corrupt',
        'depraved',
        'vicious',
        'malicious',
        'hurtful',
        'damaging',
        'destructive',
        'noxious',
        'noxious',
        'polluting',
        'contaminating',
        'pollutive',
        'toxic',
        'poisonous',
        'venomous',
        'dangerous',
        'hazardous',
        'adult',
        '18*',
        'risky',
        'pernicious',
        'fatal',
        'deadly',
        'lethal',
        'cancerous',
        'bad',
        'sample',
        'naked',
        'sex',
        'sexy',
        'erotic',
        'lustful',
        'sensual',
        'lewd',
        'indecent',
        'obscene',
        'vulgar',
        'crude',
        'explicit',
        'adult',
        '18*',
        'porn',
        'porno',
        'pornography',
        'nude',
        'playboy',
        'playgirl',
        'striptease',
        'strip',
        'undress',
        'topless',
        'bottomless',
        'lingerie',
        'bikini',
        'thong',
        'lingerie',
        'seductive',
        'passionate',
        'intimate',
        'carnal',
        'promiscuous',
        'lecherous',
        'libidinous',
        'prurient',
        'debauched',
        'decadent',
        'degenerate',
        'perverted',
        'deviant',
        'twisted',
        'fetish',
        'kinky',
        's&m',
        'bondage',
        'fetishism',
        'voyeur',
        'exhibitionist',
        'masturbate',
        'masturbation',
        'orgasm',
        'erogenous',
        'eroticism',
        'pleasure',
        'desire',
        'lust',
        'intimacy',
        'foreplay',
        'seduction',
        'stimulation',
        'libido',
        'arousal',
        'horny',
        'turn-on',
        'excitement',
        'kiss',
        'touch',
        'caress',
        'fondle',
        'petting',
        'cuddle',
        'snuggle',
        'make-out',
        'blowjob',
        'oral',
        'anal',
        'vagina',
        'penis',
        'clitoris',
        'testicles',
        'butt',
        'ass',
        'boobs',
        'breasts',
        'nipples',
        'pussy',
        'cock',
        'dick',
        'vulva',
        'scrotum',
        'intercourse',
        'sexuality',
        'sexual',
        'erotic',
        'intimate',
        'kama',
        'sutra',
        'liberation',
        'feminine',
        'masculine',
        'gender',
        'bisexual',
        'homosexual',
        'lesbian',
        'gay',
        'transgender',
        'queer',
        'heterosexual',
        'pansexual',
        'asexual',
        'orgy',
        'swinger',
        'swing',
        'polyamory',
        'threesome',
        'foursome',
        'group',
        'gangbang',
        'cuckold',
        'hotwife',
        'cheating',
        'affair',
        'flirt',
        'flirting',
        'tease',
        'teasing',
        'dirty talk',
        'roleplay',
        'fantasy',
        'kinky',
        'taboo',
        'fetish',
        'bdsm',
        'dominant',
        'submissive',
        'slave',
        'master',
        'mistress',
        'dom',
        'sub',
        'spanking',
        'whip',
        'chain',
        'collar',
        'cuff',
        'bondage',
        'blindfold',
        'gag',
        'clamps',
        'chastity',
        'cage',
        'pegging',
        'strap-on',
        'golden shower',
        'watersports',
        'rimming',
        'analingus',
        'fisting',
        'deepthroat',
        'cum',
        'creampie',
        'facial',
        'squirt',
        'ejaculation',
        'cumshot',
        'cunnilingus',
        'fellatio',
        'rimjob',
        'anilingus',
        'peg',
        'pegged',
        'strap',
        'strapped',
        'paddled',
        'dominated',
        'subservient',
        'collared',
        'gagged',
        'spanked',
        'punished',
        'tied',
        'bound',
        'chained',
        'flogged',
        'whipped',
        'clamped',
        'cuffed',
        'chaste',
        'caged',
        'fisted',
        'deepthroated',
        'squirting',
        'ejaculated',
        'creamed',
        'facialed',
        'orally',
        'anally',
        'anally',
        'vaginally',
        'orgasmic',
        'libidinous',
        'titillating',
        'provocative',
        'risqué',
        'sensual',
        'steamy',
        'raunchy',
        'spicy',
        'explicit',
        'sexy',
        'horny',
        'lustful',
        'desirable',
        'alluring',
        'seductive',
        'sultry',
        'erotic',
        'intimate',
        'passionate',
        'sizzling',
        'sensuous',
        'flirty',
        'playful',
        'naughty',
        'provocative',
        'teasing',
        'bold',
        'daring',
        'risqué',
        'raunchy',
        'dirty',
        'kinky',
        'wild',
        'frisky',
        'spicy',
        'wanton',
        'orgasmic',
        'voluptuous',
        'curvaceous',
        'buxom',
        'slinky',
        'licentious',
        'lascivious',
        'lecherous',
        'libertine',
        'debauched',
        'decadent',
        'perverted',
        'deviant',
        'twisted',
        'immoral',
        'sinful',
        'wicked',
        'unchaste',
        'loose',
        'easy',
        'promiscuous',
        'abandoned',
        'depraved',
        'corrupt',
        'debased',
        'defiled',
        'unclean',
        'impure',
        'lewd',
        'indecent',
        'obscene',
        'vulgar',
        'dirty-minded',
        'trashy',
        'smutty',
        'filthy',
        'nasty',
        'sordid',
        'salacious',
        'lubricious',
        'horny',
        'randy',
        'frisky',
        'amorous',
        'lustful',
        'racy',
        'risqué',
        'daring',
        'provocative',
        'spicy',
        'sultry',
        'steamy',
        'passionate',
        'intense',
        'ardent',
        'without cloths',
    ]

    function censorString(inputString) {
        // Use a regular expression to replace unwanted words with asterisks
        let NewinputString = inputString.replace(/[^a-zA-Z0-9 ]/g, '')
        unwantedWords.forEach(word => {
            const regex = new RegExp(`\\b${word}\\b`, 'gi')
            if (regex.test(inputString)) {
                setText('')
                alert('prompt not allowed')
                NewinputString = ''
                return ''
            }
        })

        return NewinputString
    }
    React.useEffect(() => {
        const fetchText = async () => {
            let fileName = `aud.wav`
            let fd = new FormData()
            const output = await axios({
                method: 'get',
                url: audioURL, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
                responseType: 'blob',
            })
            const selectedLang = sourceLanguage
            let files = new File([output.data], fileName, { type: 'audio/wav' })
            console.log(files)
            fd.append('file', files)
            fd.append('language', selectedLang)
            let config = {
                'Content-Type': 'multipart/form-data',
                authorization: 'UuZLRxJ3ywDe8c26vQtGPs',
            }
            axios
                .post('https://chatapi.aicte-india.org/voice-to-text', fd)
                .then(async res => {
                    setLoading(false)
                    const textResponse = res.data
                    if (
                        textResponse &&
                        textResponse.data !== '' &&
                        textResponse.data !== undefined
                    ) {
                        setText(textResponse.data.replace(/\.$/, ''))
                    }
                })
                .catch(errr => {
                    setLoading(false)
                    console.log('Invalid query!')
                })
        }
        if (audioURL !== undefined) {
            fetchText()
        }
    }, [audioURL])

    const gettoken = async () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: 'https://bharattube.aicte-india.org/api/generate-image/xyzfghik',
            headers: {},
        }

        try {
            const response = await axios.request(config)
            console.log(response.data.uuid)
            return response.data?.uuid
        } catch (error) {
            console.log(error)
        }
    }

    const generateImage = async () => {
        let prompt = ''
        if (Text == '') {
            alert('Please enter a prompt')
            return
        }

        let payload = { text: Text, outputLang: 'en-IN' }

        try {
            const res = await axios.post(
                'https://chatapi.aicte-india.org/text-to-text',
                payload,
            )

            setTransText(res.data.data)
            console.log(TransText)

            let censorStrin = censorString(res.data.data)
            if (censorStrin == '') {
                return
            }

            const url =
                'https://bharattube.aicte-india.org/api/generate-image/generate-image/v2'

            let formData = new FormData()
            formData.append('prompt', censorStrin)
            let data = {
                prompt: censorStrin,
            }
            setLoading(true)
            setImageSrc('')

            const genimagetoken = await gettoken()
            if (!genimagetoken) {
                throw new Error('Failed to retrieve token')
            }

            const response = await axios.post(url, formData, {
                headers: { UUID: genimagetoken },
            })

            console.log(response.data.base64)
            setImageSrc(response.data.base64)
            setLoading(false)
        } catch (error) {
            console.error(error)
            alert('Too many requests to generate image, please try again')
            setLoading(false)
        }
    }

    return (
        <>
            <HeaderPage />
            <section className="logoSec youtubeSessionSec">
                <div className="sessionDiv">
                    <div className="container">
                        <div
                            className="cntnrLogo"
                            style={{
                                display: 'flex',
                                alignContent: 'flex-start',
                                justifyContent: 'center',
                            }}
                        >
                            {/* <img src={bharat_voice} style={{ height: "14vh" }} alt="logo" /> */}
                            {/* <img
                className="madeInBhrt"
                src={madeinBharat}
                style={{ height: "10vh" }}
                alt="logo"
              /> */}
                        </div>
                        <div className="videoSldrCnt">
                            <h2>Anuvadini AI SpeakPic</h2>
                            <p>
                                Introducing SpeakPic: Your Personal Artist in
                                the Digital Realm, Turning the Vibrancy of
                                Bhartiya languages into Lifelike Visuals by
                                Breathing Life into Your Imagination!
                                {/* <br /> */}
                                With SpeakPic, you can select the source
                                language in your mother tongue and transform
                                your creative text using text and voice-enabled
                                keyboard. This innovative tool acts as your
                                personal virtual artist, enhancing your content
                                with lifelike visuals that capture the essence
                                of your ideas. Whether you're a writer,
                                influencer, educator, or content creator,
                                SpeakPic revolutionizes how you bring your
                                imagination to life.
                            </p>
                        </div>
                        <div className="videoSldrCnt mb-0">
                            <Link
                                to="https://youtu.be/0cyHPAHB_1Q"
                                style={{
                                    textDecoration: 'underline',
                                    color: 'blue',
                                }}
                                target="_blank"
                            >
                                Video Demonstration of Anuvadini AI SpeakPic
                            </Link>{' '}
                        </div>

                        <div
                            className="realtimevideoCnt"
                            // style={{ minHeight: 'auto' }}
                        >
                            <div className="inputGroup">
                                {!isVerified ? (
                                    <CaptchaTest
                                        isVerified={isVerified}
                                        setisVerified={setisVerified}
                                    />
                                ) : (
                                    <>
                                        <select
                                            onChange={e =>
                                                setSourceLanguage(
                                                    e.target.value,
                                                )
                                            }
                                        >
                                            <option value="" disabled selected>
                                                Select a Source language
                                            </option>
                                            {Object.keys(LanguageList).map(
                                                key => (
                                                    <option
                                                        key={key}
                                                        value={key}
                                                    >
                                                        {LanguageList[key]}
                                                    </option>
                                                ),
                                            )}
                                        </select>
                                        {sourceLanguage && (
                                            <>
                                                <div className="inputfrom">
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Your Prompt"
                                                        value={Text}
                                                        onChange={e =>
                                                            setText(
                                                                e.target.value,
                                                            )
                                                        }
                                                    />
                                                    {isRecording ? (
                                                        <>
                                                            <button
                                                                className="stopbutton button orange"
                                                                onClick={
                                                                    stopRecording
                                                                }
                                                                disabled={
                                                                    !isRecording
                                                                }
                                                            >
                                                                <Stop
                                                                    size={20}
                                                                    weight="fill"
                                                                />
                                                            </button>
                                                            {pause ? (
                                                                <>
                                                                    <button
                                                                        className="startbutton button green"
                                                                        onClick={() => {
                                                                            setPause(
                                                                                false,
                                                                            )
                                                                            setResume(
                                                                                true,
                                                                            )
                                                                        }}
                                                                    >
                                                                        <Record
                                                                            size={
                                                                                20
                                                                            }
                                                                            weight="fill"
                                                                        />
                                                                    </button>
                                                                    <button
                                                                        className="stopbutton button orange"
                                                                        onClick={() =>
                                                                            setText(
                                                                                '',
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            !isRecording
                                                                        }
                                                                    >
                                                                        <ArrowClockwise
                                                                            size={
                                                                                20
                                                                            }
                                                                            weight="bold"
                                                                        />
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button
                                                                        className="stopbutton button orange"
                                                                        onClick={() =>
                                                                            setPause(
                                                                                true,
                                                                            )
                                                                        }
                                                                    >
                                                                        <Pause
                                                                            size={
                                                                                20
                                                                            }
                                                                            weight="fill"
                                                                        />
                                                                    </button>
                                                                    {Text && (
                                                                        <button
                                                                            className="startbutton button orange"
                                                                            onClick={() =>
                                                                                setText(
                                                                                    '',
                                                                                )
                                                                            }
                                                                            disabled={
                                                                                !isRecording
                                                                            }
                                                                        >
                                                                            <ArrowClockwise
                                                                                size={
                                                                                    20
                                                                                }
                                                                            />
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <button
                                                            className="startbutton button green"
                                                            onClick={() => {
                                                                startRecording()
                                                                setText('')
                                                            }}
                                                            disabled={
                                                                isRecording
                                                            }
                                                        >
                                                            <Microphone
                                                                size={20}
                                                                weight="fill"
                                                            />
                                                        </button>
                                                    )}
                                                    <button
                                                        onClick={() =>
                                                            setvkeyboard(
                                                                !vkeyboard,
                                                            )
                                                        }
                                                        className="button orange"
                                                    >
                                                        Virtual Keyboard
                                                    </button>
                                                    <button
                                                        onClick={generateImage}
                                                        className="button orange"
                                                    >
                                                        Generate image
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>

                            {vkeyboard && (
                                <div className="inputGroup">
                                    <TranslatorInput />
                                </div>
                            )}

                            {imageSrc && (
                                <div className="inputGroup">
                                    {/* <img
                    width={"100%"}
                    src={`data:image/png;base64,${imageSrc}`}
                    alt="Generated Image"
                  /> */}
                                    <div>
                                        {/* <img src={`data:image/png;base64,${imageSrc}`} style={{width:'100%'}} alt="Base64 Image" /> */}
                                        <CanvasComponent base64img={imageSrc} />
                                        {/* Watermark */}
                                        {/* <div
        style={{
          position: 'relative',
          bottom: '25px',
          left: '88px', // Adjust the positioning as needed
          color: 'white', // Adjust the color of the watermark text
          fontSize: '16px', // Adjust the font size of the watermark text
          fontWeight: 'bold', // Adjust the font weight of the watermark text
        }}
      >
        AI Generated Image from ANUVADINI
      </div> */}
                                    </div>
                                    {/* <img
                    src={watermarkImageUrl}
                    alt="Watermark"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      opacity: 0.8,
                      height: "6vw",
                      pointerEvents: "none", // To allow interaction with video
                    }}
                  /> */}
                                </div>
                            )}
                            {loading ? (
                                <div className="loading-overlay">
                                    <div className="load">
                                        <CirclesWithBar
                                            height="100"
                                            width="100"
                                            color="#4fa94d"
                                            outerCircleColor="#4fa94d"
                                            innerCircleColor="#4fa94d"
                                            barColor="#4fa94d"
                                            ariaLabel="circles-with-bar-loading"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                            visible={true}
                                        />
                                        <h4>Loading...</h4>
                                    </div>
                                </div>
                            ) : (
                                <>{imageSrc ? null : <ImageContainer />}</>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TextToImage
